import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { getUserMessage } from './../../../../actions/facilita-api';
import { LoadingState } from '../../../../_common/loadingState';
import { updateDeathDeclaration } from './../../../../actions/facilita-api';
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';

//userMessageByIdUrl


export const Step2 = ({deathDeclaration, deceasedUser, userId, message, isLoading}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        dispatch(getUserMessage(deathDeclaration.userId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    if(R.isNil(message)){
        return (
            <article className="flex-column mb-auto h-100 scroll-default rounded">
                <LoadingState />
            </article>
        );
    }
    let messageLines = message.split("\n");

    return (
        <article className="view-calc pt-3 mb-auto">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-3">Vous avez un message</h1>
                </header>
            </div>
            <div className="auto-view scroll-auto py-4">
                <div className="container-fluid">
                    <section className="block">
                        {
                            R.isNil(message) || R.isEmpty(message) ?
                                ''
                            :
                            <>
                            <div className="card p-4 bg-common rounded">                            
                                { messageLines.map(function(item, idx) {
                                    return (
                                        <p className="lh-base mb-0" key={idx}>{item}<br /></p>                                        
                                    )
                                })}
                                {
                                    !R.isNil(message) && !R.isEmpty(message) ? <p className="fs-3 text-muted lh-1 mb-0 text-right">{deathDeclaration.firstName} {deathDeclaration.lastName}</p>  : ''
                                }
                            </div>
                            <hr className="my-4"/>
                            </>

                        }

                        {
                            deceasedUser.createdByRepresentative ? 
                                <p className="lh-lg">Nous nous associons pleinement à votre chagrin et sommes présent pour vous accompagner afin de pouvoir établir tous les courriers dans les délais légaux, de les envoyer et surtout de vous soulager dans ce moment particulièrement difficile.
                                    <br/>Vous avez à disposition un espace dédié pour déposer tous les documents qui seront nécessaires pour vous et votre famille.
                                    <br/>Nous vous prions de recevoir nos très sincères condoléances.
                                </p>
                            :
                                <p className="lh-lg">L’équipe d’Assist@ s’associe pleinement à votre chagrin et est présent pour vous accompagner dans le dossier qu’a fait votre proche.
                                    <br/>Il a listé l’intégralité des organismes avec lesquels il était en lien afin de pouvoir établir tous les courriers dans les délais légaux, de les envoyer et surtout de vous soulager dans ce moment particulièrement difficile.
                                    <br/>Vous avez à disposition un espace dédié pour déposer tous les documents qui seront nécessaires pour vous et votre famille.
                                    <br/>Vous n’avez rien à régler tout a été pris en charge par votre proche.
                                    <br/>Nous vous prions de recevoir nos très sincères condoléances.
                                </p>
                        }
                        <p className="h5 lh-base font-weight-normal ml-auto text-right"><i>Aurélie Fournier</i><br/><span className="fs-3 text-muted lh-1">Fondatrice</span></p>
                    </section>
                    {/* <img className="img-fluid img-contain float-right" src={signature} alt="signature" /> */}
                </div>
            </div>
            <div className="container-fluid">
                <footer className="d-block mt-auto mb-sm text-right w-100">
                    <Link to={`/facilita/${deceasedUser.id}/declarer/step1`} className="btn btn-faded px-md-gutter mr-3">Retour</Link>
                    {
                        isLoading.includes(loadings.UPDATING_DECLARATION) ?
                            <button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                        :
                            <button type="button" className="btn btn-info loading-btn px-md-gutter px-4" onClick={async (event) => {
                                event.preventDefault();
                                dispatch(updateDeathDeclaration(deceasedUser.id, {...deathDeclaration, onBoardingStep: 3}))
                                .then(() => history.push(`/facilita/${deceasedUser.id}/declarer/step3`))
                            }}>Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                    }
                </footer>
            </div>
        </article>
    )
}